var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { createBrowserClient } from "@slardar/web/sg";
import { Region, SDK_BID, VERSION } from "../constants/env";
class SlardarContainer {
  constructor(config) {
    this.sendEvent = (data) => {
      if (this._client && this._client.sendEvent) {
        this._client.sendEvent(data);
      }
    };
    this.reportActualFMP = () => {
    };
    const { region, bid: consumerBid, mode, slardar: customSlardarConfig } = config;
    this._client = createBrowserClient();
    let defaultSlardarConfig = {};
    switch (region) {
      case Region.US_EASTRED:
      case Region.EU_TTP:
      case Region.EU_TTP2: {
        defaultSlardarConfig = {
          domain: "https://mon-i18n.tiktokv.com",
          pluginPathPrefix: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins"
        };
        break;
      }
      case Region.US_TTP:
      case Region.US_TTP2: {
        defaultSlardarConfig = {
          domain: "https://mon16-normal-useast5.tiktokv.us",
          pluginPathPrefix: "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins"
        };
        break;
      }
      case Region.US_EAST:
      case Region.SINGAPORE_CENTRAL:
      default: {
        defaultSlardarConfig = {
          domain: "https://mon.tiktokv.com",
          pluginPathPrefix: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins"
        };
        break;
      }
    }
    if (this._client) {
      this._client("init", __spreadProps(__spreadValues(__spreadValues({}, defaultSlardarConfig), customSlardarConfig), {
        bid: SDK_BID,
        pid: consumerBid ? consumerBid : window.location.href,
        release: VERSION,
        env: mode,
        plugins: {
          pageview: false,
          jsError: false,
          tti: false,
          performance: false,
          resource: false,
          ajax: false,
          fetch: false,
          fmp: false,
          blankScreen: false
        }
      }));
      this._client("start");
    }
  }
}
const createSlardarClientAndInit = (config) => {
  let slardarContainer = null;
  if ((config == null ? void 0 : config.slardar) !== false) {
    try {
      slardarContainer = new SlardarContainer(config);
    } catch (e) {
    }
  }
  return slardarContainer;
};
export {
  createSlardarClientAndInit
};
